export default __webpack_public_path__ + "static/media/information.c0a394bb.svg";